// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RsFU","clinicsSelect":"styles_clinicsSelect__37_Ji"};